import { render } from "./preloader.vue?vue&type=template&id=af851da2&scoped=true"
import script from "./preloader.vue?vue&type=script&lang=js"
export * from "./preloader.vue?vue&type=script&lang=js"

import "./preloader.vue?vue&type=style&index=0&id=af851da2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af851da2"]])

export default __exports__